import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Control from "./pages/Control";
import Display from "./pages/Display";
import CourtHub from "./pages/CourtHub";
import CourtScreen from "./pages/CourtScreen";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/control/:matchId" element={<ProtectedRoute><Control /></ProtectedRoute>} />
          <Route path="/display" element={<Display />} />
          <Route path="/court/:courtId" element={<CourtHub />} />
          <Route path="/court/:courtId/screen" element={<CourtScreen />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </AuthProvider>
  );
}

export default App;
